import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Row, Col } from 'components/grid';
import ProgressBar from 'components/progressBar';

import icChecked from 'assets/svgs/checked.svg';

const ProgressBarLabel = styled.p`
  ${({ theme }) => theme.typograph.paragraphRegular}
  margin-right: 16px;
`;

const ProgressBarContainer = styled(Row)`
  margin-bottom: 16px;
`;

const ProgressBarCol = styled(Col)`
  display: flex;
  align-items: center;
`;

const ImporterProgressBar = ({ label, progress }) => (
  <ProgressBarContainer>
    <Col col={4} xl={3}>
      <Row alignItems="center">
        <ProgressBarLabel>
          {label}
        </ProgressBarLabel>
        {progress === 100 && <img src={icChecked} alt="upload file complete icon" />}
      </Row>
    </Col>
    <ProgressBarCol col={7} xl={8}>
      {progress !== 100 && <ProgressBar progress={progress} />}
    </ProgressBarCol>
  </ProgressBarContainer>
);

ImporterProgressBar.propTypes = {
  label: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
};

export default ImporterProgressBar;
